"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('Options');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "Options" */ './lazyIndex');
});
// Export delay loaded actions
exports.lazyMountAndShowFullOptions = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.mountAndShowFullOptions; });
// Export delay loaded components
exports.QuickOptions = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.QuickOptions; });
// Export synchronous utils
var getOptionRouteState_1 = require("./utils/getOptionRouteState");
exports.getOptionRouteState = getOptionRouteState_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/index.js
// module id = 2050
// module chunks = 38 40 43 65 105